import React from "react";
import SectionHeader from "./SectionHeader";
import FadeIn from "./FadeIn";

export default function School() {
  const education = [
    {
      school: "Višja šola L.I.V.E",
      degree: "Računalništvo in informatika",
      period: "2025 — Ongoing (Expected 2027)",
      details: "Advanced studies in Computer Science and Informatics.",
    },
    {
      school: "Srednja elektro-računalniška šola, Maribor",
      degree: "Tehnik računalništva",
      period: "2018 — 2022",
      details: "Computer Technician specialization with focus on web and systems programming.",
    },
  ];

  return (
    <section id="education" className="w-full py-28 md:py-36 px-6 md:px-12 bg-Base border-t hairline selection:bg-Sapphire selection:text-Base">
      <div className="max-w-4xl w-full mx-auto">
        <SectionHeader number="04" label="Studies" title="Education" />

        <FadeIn>
        <div>
          {education.map((edu, index) => (
            <div
              key={index}
              className="grid md:grid-cols-[12rem_1fr] gap-2 md:gap-8 border-t hairline py-8"
            >
              <span className="label-caps pt-1.5">{edu.period}</span>

              <div>
                <h3 className="font-display font-medium text-Text text-2xl mb-1">
                  {edu.school}
                </h3>
                <h4 className="font-mono text-sm text-Sapphire mb-4">
                  {edu.degree}
                </h4>
                <p className="text-Subtext0 font-sans text-base max-w-xl leading-relaxed">
                  {edu.details}
                </p>
              </div>
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
